module.exports = __webpack_public_path__ + "img/we-are-customer-driven.6d7042b8.png";